import React from "react";
import { saveActivity } from '../../common/commonService';

class AdviceComponent extends React.Component {
    constructor(props) {
        super();
        this.state = {
            adviceIndex: 0,
            adviceCompoContent: [{
                heading: "The 3 Keys to Aggression",
                title: "Control",
                description: "Try to be the aggressor rather than passively calling.",
                image: "/images/PreFlopAggression/advice1.png"
            },
            {
                heading: "",
                title: "Position",
                description: "Late position’s best as you have more information & less opponents",
                image: "/images/PreFlopAggression/advice2.png"
            },
            {
                heading: "",
                title: "Starting Hands",
                description: "The better your cards the better your chances post flop",
                image: "/images/PreFlopAggression/advice3.png"
            },]
        }
    }

    saveNavActivity = () => {
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = "ClickAggressionTabAdvisedNavigate";
        track.hit_attribute1 = this.props.gameType;
        track.hit_attribute2 = "tab-" + (this.state.adviceIndex + 1);
        saveActivity(track);
    }

    moveLeft = () => {
        if (this.state.adviceIndex === 0) {
            this.setState({ adviceIndex: (this.state.adviceCompoContent.length - 1) }, () => {
                this.saveNavActivity()
            })
        } else {
            this.setState({ adviceIndex: (this.state.adviceIndex - 1) }, () => {
                this.saveNavActivity()
            })
        }
    }
    moveRight = () => {
        if (this.state.adviceIndex === (this.state.adviceCompoContent.length - 1)) {
            this.setState({ adviceIndex: 0 }, () => {
                this.saveNavActivity()
            })
        } else {
            this.setState({ adviceIndex: (this.state.adviceIndex + 1) }, () => {
                this.saveNavActivity()
            })
        }
    }

    render() {
        return (
            <div className={" advice_compo_Wrapper " + this.props.className}>
                {this.state.adviceCompoContent && this.state.adviceCompoContent.length > 0 &&
                    <div>
                        < div className={`advice_heading ${this.state.adviceCompoContent[this.state.adviceIndex].title === 'Position'  && 'marginThePosImage' }`}>
                            {this.state.adviceCompoContent[this.state.adviceIndex].heading}
                        </div>
                        <div className="advice_image_wrap" >
                            <img className="advice_image" src={this.props.baseUrlImg + this.state.adviceCompoContent[this.state.adviceIndex].image} alt="adviceimg" />
                        </div>
                        <div className="advice_bullet_and_control_wrapper">
                            <i className="fa fa-angle-left advice_controls" style={{ cursor: 'pointer' }} onClick={this.moveLeft} />
                            <div className="advice_bullets_wrap">
                                {[0, 1, 2].map((index) => {
                                    return <div key={index} className={"advice_bullet" + (index === this.state.adviceIndex ? " advice_selected_bullet" : "")}>
                                    </div>
                                })}
                            </div>
                            <i className="fa fa-angle-right advice_controls" style={{ cursor: 'pointer' }} onClick={this.moveRight} />
                        </div>
                        <div className="advice_title">
                            {this.state.adviceCompoContent[this.state.adviceIndex].title}
                        </div>
                        <div className="advice_description">
                            {this.state.adviceCompoContent[this.state.adviceIndex].description}
                        </div>
                    </div>}
            </div>
        )
    }
}

export default AdviceComponent;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/AdviceComponent.js
 **/